//////// GHG 3_4 EA
const threeFourSchema = {
  title: "3.4 Upstream Transportation and Distribution",
  addAPI: "cat3_1AddEmissionActivityAPI",
  cat: "cat3_1",
  category: "3_1",
  EATitle: "Emission Activity",
  fields: [
    {
      key: "itemName",
      level: 1,
      type: "input",
      label: "Purchased Product Name",
      resetOnChange: false,
      required: true,
    },
    ////////Vehicle Model
    {
      key: "vehicleModel",
      level: 1,
      type: "input",
      label: "Vehicle Model",
      resetOnChange: false,
      required: true,
    },
    ////////計算方法
    {
      key: "calculationId",
      level: 2,
      type: "select",
      label: "Calculation Method",
      optionsParamFrom: { value: "3_1" },
      optionsAPI: "cat3Calculation",
      resetOnChange: true,
      required: true,
    },
    ////////is distance not changed?
    {
      key: "isStatic",
      level: 3,
      type: "select",
      label: "Is distance not change ?",
      showIf: {
        all: [
          { level: 2, key: "calculationId", notEmpty: true },
          { level: 2, key: "calculationId", eq: 1 },
        ],
      },
      optionsParamFrom: { level: 2, key: "calculationId" },
      optionsAPI: "isDistanceChangeAPI",
      required: true,
    },
    //////// Origin
    {
      key: "origin",
      level: 4,
      type: "input",
      label: "Origin",
      showIf: {
        all: [
          { level: 2, key: "calculationId", eq: 1 },
          { level: 3, key: "isStatic", notEmpty: true },
          { level: 3, key: "isStatic", eq: true },
        ],
      },
    },
    //////// Destination
    {
      key: "destination",
      level: 4,
      type: "input",
      label: "Destination",
      showIf: {
        all: [
          { level: 2, key: "calculationId", eq: 1 },
          { level: 3, key: "isStatic", notEmpty: true },
          { level: 3, key: "isStatic", eq: true },
        ],
      },
    },
    //////// Distance
    {
      key: "distance",
      level: 4,
      type: "input",
      label: "Distance (Unit: km)",
      showIf: {
        all: [
          { level: 2, key: "calculationId", eq: 1 },
          { level: 3, key: "isStatic", notEmpty: true },
          { level: 3, key: "isStatic", eq: true },
        ],
      },
      placeholder: 0,
      required: true,
    },
    {
      type: "block",
      showIf: {
        all: [
          { level: 2, key: "calculationId", eq: 1 },
          { level: 3, key: "isStatic", eq: true },
          { level: 3, key: "isStatic", notEmpty: true },
        ],
      },
    },
    {
      type: "block",
      showIf: {
        all: [
          { level: 2, key: "calculationId", eq: 2 },
          { level: 2, key: "calculationId", notEmpty: true },
        ],
      },
    },
    {
      type: "block",
      showIf: {
        all: [
          { level: 2, key: "calculationId", eq: 3 },
          { level: 2, key: "calculationId", notEmpty: true },
        ],
      },
    },
    {
      key: "isBiomassActivity",
      level: 5,
      type: "trigger",
      label: "Biomass",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
      defaultValue: false,
      tooltip: 'If biomass / biofuel / biogas is used, click "Yes".',
      required: true,
      resetOnChange: true,
    },
    {
      key: "isBiomassSeparate",
      level: 6,
      type: "trigger",
      label: "Report each greenhouse gas separately ?",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
      defaultValue: false,
      required: true,
      resetOnChange: true,
      showIf: {
        all: [
          { level: 5, key: "isBiomassActivity", eq: true },
          { level: 5, key: "isBiomassActivity", notEmpty: true },
        ],
      },
    },
  ],
};

export default threeFourSchema;
